import { getSession } from "../helpers";
import { deleteCookie, getCookie, setCookie } from "../storage";
import {
  FRONT_OFFICE_URL,
  PROFILE_TIMESTAMP_COOKIE_KEY,
  PROFILE_TIMESTAMP_STORAGE_KEY,
  USER_PHOTO_COOKIE_KEY,
  USER_PHOTO_STORAGE_KEY,
} from "../settings";
import { HeaderData } from "./models/header-data";
import dayjs from "dayjs";
import { catchError } from "../catchErrors";

function checkHeaderDataOnLocalStorage(): boolean {
  const headerDataJson =
    localStorage.getItem(PROFILE_TIMESTAMP_STORAGE_KEY) ?? "";
  let headerData = !!headerDataJson ? JSON.parse(headerDataJson) : undefined;
  return !!headerData && !!headerData?.name;
}

function checkProfilePhotoOnLocalStorage(): boolean {
  const profilePhotoString = localStorage.getItem(USER_PHOTO_STORAGE_KEY) ?? "";
  return !!profilePhotoString && profilePhotoString != "";
}

export function getHeaderData(): any {
  const session = getSession();
  const country = session.countryId;
  const userPhotoTimestamp = getCookie(USER_PHOTO_COOKIE_KEY);
  const profileTimestamp = getCookie(PROFILE_TIMESTAMP_COOKIE_KEY);
  let url = `${FRONT_OFFICE_URL}AccountWorker/GetHeaderData?countryId=${country}`;

  if (userPhotoTimestamp && checkProfilePhotoOnLocalStorage())
    url = url.concat(`&timestampFile=${userPhotoTimestamp}`);

  if (profileTimestamp && checkHeaderDataOnLocalStorage())
    url = url.concat(`&timestampProfile=${profileTimestamp}`);

  return $.ajax({
    url: url,
    type: "post",
    dataType: "json",
    headers: {
      Authorization: `Bearer ${session.jwToken}`,
    },
  })
    .done((_headerData: HeaderData) => {
      const cookieExpirationDate: Date = dayjs().add(1, "months").toDate();

      let headerData: HeaderData;
      if (
        dayjs(_headerData.profileTimestamp).isSame(dayjs(profileTimestamp)) &&
        checkHeaderDataOnLocalStorage()
      ) {
        headerData = JSON.parse(
          localStorage.getItem(PROFILE_TIMESTAMP_STORAGE_KEY) ?? ""
        );
      } else {
        headerData = _headerData;
        setCookie(
          PROFILE_TIMESTAMP_COOKIE_KEY,
          headerData.profileTimestamp,
          "/",
          cookieExpirationDate
        );
        localStorage.setItem(
          PROFILE_TIMESTAMP_STORAGE_KEY,
          JSON.stringify(headerData)
        );
      }

      if (_headerData.profilePhotoTimestamp == null) {
        deleteCookie(USER_PHOTO_COOKIE_KEY, "/");
        localStorage.removeItem(USER_PHOTO_STORAGE_KEY);
      }

      if (_headerData.profilePhoto != null) {
        setCookie(
          USER_PHOTO_COOKIE_KEY,
          _headerData.profilePhotoTimestamp,
          "/",
          cookieExpirationDate
        );
        localStorage.setItem(USER_PHOTO_STORAGE_KEY, _headerData.profilePhoto);
      }

      return headerData;
    })
    .catch(catchError);
}
